// Utility function to handle API response
async function handleApiResponse(response) {
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return await response.json();
}

// Utility function to create options object for fetch
function createFetchOptions(
  method,
  data = null,
  token = null,
  isFileUpload = false
) {
  const options = {
    method: method,
    headers: {},
  };

  if (token) {
    options.headers['Authorization'] = `Bearer ${token}`;
  }

  if (isFileUpload) {
    options.body = data;
    options.headers['Content-Type'] = 'multipart/form-data';
  } else {
    options.headers['Content-Type'] = 'application/json';
    if (data) {
      options.body = JSON.stringify(data);
    }
  }

  return options;
}

export async function makeApiRequest(
  endpoint,
  method = 'GET',
  data = null,
  token = null
) {
  const url = `${process.env.REACT_APP_API_PREFIX}${endpoint}`;
  const options = createFetchOptions(method, data, token);

  try {
    const response = await fetch(url, options);

    // Check if the response status is not OK (e.g., 4xx or 5xx)
    if (!response.ok) {
      const errorData = await response.json(); // Attempt to get error details from the response body
      const error = new Error('API request failed');
      error.response = errorData; // Attach the response data to the error
      error.status = response.status; // Include status code in the error
      throw error; // Throw error to be handled by caller
    }

    return await handleApiResponse(response); // Return success response
  } catch (error) {
    console.error('Error making API request:', error);
    throw error; // Re-throw the error so it can be handled by the caller
  }
}

export async function uploadFile(endpoint, file, data = {}, token = null) {
  const url = `${process.env.REACT_APP_API_PREFIX}${endpoint}`;

  const formData = new FormData();
  formData.append('file', file);

  // Append additional data, if any
  Object.keys(data).forEach((key) => {
    formData.append(key, data[key]);
  });

  const options = {
    method: 'POST',
    body: formData,
    headers: {},
  };

  if (token) {
    options.headers['Authorization'] = `Bearer ${token}`;
  }

  try {
    const response = await fetch(url, options);
    return await response.json(); // or handleApiResponse(response) if you have the utility function
  } catch (error) {
    console.error('Error uploading file:', error);
    throw error; // Re-throw the error so it can be handled by the caller
  }
}

export async function getFile(endpoint, token = null) {
  const url = `${process.env.REACT_APP_API_PREFIX}${endpoint}`;
  const options = {
    method: 'GET',
    headers: {},
  };

  if (token) {
    options.headers['Authorization'] = `Bearer ${token}`;
  }

  try {
    const response = await fetch(url, options);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Return the file as a Blob
    return await response.blob();
  } catch (error) {
    console.error('Error fetching file:', error);
    throw error; // Re-throw the error so it can be handled by the caller
  }
}
